import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache) {
  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_router_view)]);
}